import React, { useEffect, useState } from "react";
import style from "./BookedInvoice.module.css";
import HeadingBar from "./HeadingBar";
import MenuBar from "./MenuBar";
import axios from "axios";
import MainSeachBar from "./MainSeachBar";
import moment from "moment";
import DateRangePicker from "./DateRangePicker";
import { toast } from "react-toastify";
import { API_BASE_URL } from "./config.js";
import UplaodInvoice from "./UplaodInvoice.js";

const formatDateForAPI = (date) => {
  const d = new Date(date);
  return `${d.getFullYear()}${String(d.getMonth() + 1).padStart(
    2,
    "0",
  )}${String(d.getDate()).padStart(2, "0")}`;
};
const BookedInvoice = () => {
  const vendorDataRaw = sessionStorage.getItem("vendordata");
  const vendorInfo = vendorDataRaw ? JSON.parse(vendorDataRaw) : null;
  const vendorCode = vendorInfo?.CardCode || "";
  const [selectedLocation, setSelectedLocation] = useState("");
  const [locations, setLocations] = useState([]);
  const today = new Date();
  const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
  const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
  const [selectedValue, setSelectedValue] = useState("O");
  const [activeTab, setActiveTab] = useState("BOOKED");
  const isEmbedded = sessionStorage.getItem("mode") === "embedded";
  const [bookedinvoiceData, setBookedInvoiceData] = useState([]);
  const [fromDate, setFromDate] = useState(
    firstDayOfMonth.toISOString().split("T")[0],
  );
  const [toDate, setToDate] = useState(
    lastDayOfMonth.toISOString().split("T")[0],
  );
  const handleDateChange = (start, end) => {
    setFromDate(start);
    setToDate(end);
    fetchBookedInvoiceData(start, end, selectedValue, selectedLocation);
  };
  const fetchBookedInvoiceData = async (from, to, status, location) => {
    if (!vendorCode) return;
    try {
      const res = await axios.get(
        `${API_BASE_URL}/BookedInvoices?VendorCode=${vendorCode}&FromDt=${formatDateForAPI(
          from,
        )}&ToDt=${formatDateForAPI(to)}&Status=${status}&Location=${location}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      setBookedInvoiceData(res.data);
    } catch (error) {
      console.error("Error fetching PO data:", error);
    }
  };

  useEffect(() => {
    fetchLocations();

    const start = moment().startOf("quarter").format("YYYY-MM-DD");
    const end = moment().endOf("quarter").format("YYYY-MM-DD");

    setFromDate(start);
    setToDate(end);

    // pass all 4 params correctly
    fetchBookedInvoiceData(start, end, selectedValue, selectedLocation);
  }, [vendorCode]);

  const fetchLocations = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/location`, {
        headers: { "Content-Type": "application/json" },
      });

      if (Array.isArray(res.data)) {
        setLocations(res.data);
      } else {
        console.warn("Unexpected location response:", res.data);
      }
    } catch (error) {
      console.error("Error fetching locations:", error);
      toast.error("Failed to fetch locations.");
    }
  };
  const handleSearch = () => {
    fetchBookedInvoiceData(fromDate, toDate, selectedValue, selectedLocation);
  };
  return (
    <div className={style.BookedInvoiceDetails}>
      {!isEmbedded && (
        <div className={style.HeadingBarContainer}>
          <HeadingBar />
        </div>
      )}
      <div className={style.BookedInvoiceDetailsContainer}>
        <div className={style.MenuBarContainer}>
          <MenuBar />
        </div>
        <div className={style.MainBookedInvoiceDetailsContainer}>
          <div className={style.MenuNameDetails}>Invoices</div>

          <div className={style.TabBar}>
            <button
              className={`${style.TabButton} ${
                activeTab === "BOOKED" ? style.ActiveTab : ""
              }`}
              onClick={() => setActiveTab("BOOKED")}
            >
              Booked Invoices
            </button>

            <button
              className={`${style.TabButton} ${
                activeTab === "UPLOAD" ? style.ActiveTab : ""
              }`}
              onClick={() => setActiveTab("UPLOAD")}
            >
              Upload Invoices
            </button>
          </div>
          {activeTab === "BOOKED" && (
            <>
              <div className={style.filterArea}>
                <div className={style.pofilter}>
                  <div>Status</div>
                  <select
                    value={selectedValue}
                    onChange={(e) => {
                      const newStatus = e.target.value;
                      setSelectedValue(newStatus);

                      fetchBookedInvoiceData(
                        fromDate,
                        toDate,
                        newStatus,
                        selectedLocation,
                      );
                    }}
                  >
                    <option value="O">Open</option>
                    <option value="C">Closed</option>
                  </select>

                  {/* 🔹 Location Dropdown */}
                  <div>Location</div>
                  <select
                    value={selectedLocation}
                    onChange={(e) => {
                      const newLoc = e.target.value;
                      setSelectedLocation(newLoc);
                      fetchBookedInvoiceData(
                        fromDate,
                        toDate,
                        selectedValue,
                        newLoc,
                      );
                    }}
                  >
                    <option value="">All</option>
                    {locations.map((loc, i) => (
                      <option key={loc.Code} value={loc.Code}>
                        {loc.Location}
                      </option>
                    ))}
                  </select>
                </div>
                <div className={style.datearea}>
                  <DateRangePicker
                    className={style.daterangepicker}
                    onDateChange={handleDateChange}
                    startDate={fromDate}
                    endDate={toDate}
                  />
                  <button onClick={handleSearch}>Search</button>
                </div>
              </div>

              <div className={style.MainArea}>
                <div className={style.BookedInvoicetable}>
                  <table>
                    <thead>
                      <tr>
                        <td>Star Booking #</td>
                        <td>Booking Date</td>
                        <td>Vendor Invoice #</td>
                        <td>Vendor Invoice Date</td>
                        <td>Location</td>
                        <td>Taxable Amount</td>
                        <td>Tax Amount</td>
                        <td>Total Amount</td>
                        <td>Open Amount</td>
                        <td>Status</td>
                      </tr>
                    </thead>
                    <tbody>
                      {bookedinvoiceData.length > 0 ? (
                        bookedinvoiceData.map((item, index) => (
                          <tr key={index}>
                            <td>{item.StarDocNum}</td>
                            <td>{item.StarDocDate}</td>
                            <td>{item.VendorDocNo}</td>
                            <td>{item.VendorDocDate || "-"}</td>
                            <td>{item.Location || "-"}</td>
                            <td className="text-end amount-cell">
                              {item.DocCur}{" "}
                              {Number(item.TaxableAmt).toLocaleString("en-IN")}
                            </td>
                            <td className="text-end amount-cell">
                              {item.DocCur}{" "}
                              {Number(item.TaxAmt).toLocaleString("en-IN")}
                            </td>
                            <td className="text-end amount-cell">
                              {item.DocCur}{" "}
                              {Number(item.DocTotal).toLocaleString("en-IN")}
                            </td>
                            <td className="text-end amount-cell">
                              {item.DocCur}{" "}
                              {Number(item.OpenAmount).toLocaleString("en-IN")}
                            </td>

                            <td>{item.Status}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td
                            colSpan="12"
                            style={{
                              textAlign: "center",
                              padding: "12px",
                              color: "#999",
                            }}
                          >
                            No Booked Invoice Found. Please select a Date range.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </>
          )}

          {activeTab === "UPLOAD" && <UplaodInvoice />}
        </div>
      </div>
    </div>
  );
};

export default BookedInvoice;
